import React, { Fragment, useContext } from "react"
import { makeStyles } from "@material-ui/core"

import { UserContext } from "../Contexts/UserContext/UserContext"
import { getLog } from "../helpers/helpers"


const useStyles = makeStyles((theme) => ({
    coinLogo: {
        margin: "0 auto",
        display: "flex",
        marginBottom: "1em",
    },
}))


/**
 *  props:
 * 		no specific props, pass any props to transfer them
*/
export default function CoinHeader(props) {
    const userContext = useContext(UserContext)
    const classes = useStyles()
    const classname = "CoinHeader: "
    const function_id = classname
    const log = getLog(function_id)

    const coinProps = userContext.get_selected_coin_props()
    // examples: coinProps.tokenid ticker .name .logo .color
    log("coinProps.tokenid=", coinProps.tokenid)

    return (
        <Fragment>
            <img height="80px" src={coinProps.logo} alt={coinProps.ticker + " logo"}
                className={classes.coinLogo} />
            <h2 style={{ color: coinProps.color }}>
                {coinProps.name} ({coinProps.ticker})
            </h2>
        </Fragment>
    )
}
